'use strict';

define('features/vehicle-info/trim.xform',['lib/readable-monetize'], function (readableMonetize) {
  function __hasValue(obj, key, value) {
    return obj.hasOwnProperty(key) && obj[key] === value;
  }

  // TODO: use series map
  function __modelTitle(seriesTitle) {
    var title = seriesTitle;
    title = title.replace(/prius c/gi, '');
    title = title.replace(/prius v/gi, '');
    title = title.replace(/Prius \<i\>v\<\/i\>/gi, '');
    title = title.replace(/Prius \<i\>c\<\/i\>/gi, '');
    title = title.replace(/Prius /gi, '');
    return title;
  }

  function __featuresSplit(featuresStr) {
    return featuresStr.split('&lt;br&gt;&amp;bull; ');
  }

  // Used by Vehicle Info Model slideshow.
  // ghetto params, but needed to move this out
  return function trimXform(params) {
    var trimArr = params.trims;
    var seriesParam = params.series;
    var seriesSanitized = params.seriesSanitized;
    var yearParam = params.year;
    var category = params.cat;
    var trimArrTemp = [];

    var kount = 0;
    if (trimArr !== null) {
      kount = trimArr.length;
    }
    for (var i = 0; i < kount; i += 1) {
      var trimObj = {
        msrp: trimArr[i].msrp,
        cityMpg: trimArr[i].city_mpg,
        hwyMpg: trimArr[i].hwy_mpg,
        year: yearParam,
        series: seriesParam,
        seriesSanitized: seriesSanitized,
        brand: 'Toyota',
        model: '',
        code: '',
        trim_id: trimArr[i].trim_id,
        trim_name: trimArr[i].trim_name,
        trim_msrp: trimArr[i].msrp.toString(),
        dataLayer: {
          series_code: seriesParam,
          series_brand: 'Toyota',
          series_year: yearParam.toString(),
          series_number: trimArr[i].trim_id.toString(),
          series_vehicleid: '', // unavail
          series_inventory_type: 'New',
          series_category: category,
          series_fuel_type: '', // unavial
          series_msrp: trimArr[i].msrp.toString(),
          series_grade: '', // updated below
          series_engine: '', // updated below (if exists)
          series_transmission: '', // updated below (if exists)
          series_body_style: '', // unavail
          series_packages: '',
          series_color_ext: '',
          series_color_int: '',
          series_color_ext_code: '',
          series_color_int_code: '',
          series_accessories_name: ''
        }
      };

      /*-----------------------------------------------------------------
      Extract grade from our CLS response
      - Run a test on each obj in our series_trim_attributes array
      -** We're interested in finding the obj that contains the property named 'type' with a value of 'grade'
      - this is where our model title (LE, XLE, etc) and list of features is stored
      -------------------------------------------------------------------*/
      var test = trimArr[i].series_trim_attributes;

      test.some(function (currentObj) {
        var hasGrade = __hasValue(currentObj, 'type', 'grade');
        if (hasGrade) {
          trimObj.dataLayer.series_grade = currentObj.name;
          trimObj.model_code = currentObj.code;
          var featuresInit = currentObj.features;
          // normalize the bulls (only the first item in our 'new', crummy data, since these only contain a single item)
          var normalizeBulls = featuresInit[0].replace(/<br\/> &bull;/g, '<br/>&bull;');
          var normalizeBullsMore = normalizeBulls.replace(/<br> &bull;/g, '<br/>&bull;');
          // var normalizeBullsAgain = normalizeBullsMore.replace(/<br>&bull;/g, '<br/>&bull;');
          var normalizeBullsAgain = normalizeBullsMore.replace(/<br>&bull;/g, '<br/>');
          var normalizeBullsFinal = normalizeBullsAgain.replace(/&bull;/g, ''); // remove any remaining bulls

          // then split
          var newFeatures = normalizeBullsFinal.split('<br/>');
          // drop the first one, if it's empty (it happens, if data leads with a <br/>&bull;)
          if (newFeatures[0] === '') {
            newFeatures.splice(0, 1);
          }

          // Only use these new arrays if the original features is an array that contains a single item
          // This is our 'newest' crummy data
          if (featuresInit.length === 1) {
            trimObj.features = newFeatures;

          // If there's more than one item in the original, then this is our slightly older
          // yet still crummy data (as of 8/19/16, only ALL the prius and priusc use this)
          } else {
            var piecesToDrop = ['sup&gt', '&amp', ' &amp', 'reg', '&lt', '/sup&gt', 'br&gt', 'bull', '&laquo', '&#128', '&#153', '<br/>&bull;',
              ' with EV [2016_prius_hybrid_caution]/ECO/POWER Modes',
              ' with EV [2016_priusc_ev_mode], [2016_priusc_hybrid_caution]/ECO Modes',
              'with EV [2016_priusc_ev_mode], [2016_priusc_hybrid_caution]/ECO Modes',
              ' with EV [2016_prius_hybrid_caution], [2016_prius_ev_mode]/ECO/POWER Modes'];

            var replaceString = function (oldS, newS, fullS) {
              return fullS.split(oldS).join(newS);
            };
            trimObj.features = featuresInit;
            // reverse loop since we're using splice to drop array items
            for (var index = trimObj.features.length; index--;) {
              var val = trimObj.features[index];

              if (piecesToDrop.indexOf(val) > -1) {
                trimObj.features.splice(index, 1);

              // Prius  (also in piecesToDrop, above)
              // } else if (trimObj.features[2] === ' Hybrid Synergy Drive&lt') {
              //	trimObj.features[2] = 'Hybrid Synergy Drive with EV [2016_prius_hybrid_caution], [2016_prius_ev_mode]/ECO/POWER Modes';
              } else if (featuresInit.indexOf(' Hybrid Synergy Drive&lt') > -1) {
                trimObj.features[index] = 'Hybrid Synergy Drive with EV[2016_prius_ev_mode]/ECO/POWER Modes';
              } else if (featuresInit.indexOf(' Hybrid Synergy Drive&Atilde') > -1) {
                trimObj.features[index] = 'Hybrid Synergy Drive with EV[2016_prius_ev_mode]/ECO/POWER Modes';

              // } else if (trimObj.features[2] === ' Hybrid Synergy Drive&Atilde') {
              // 	trimObj.features[2] = 'Hybrid Synergy Drive with EV [2016_priusc_ev_mode], [2016_priusc_hybrid_caution]/ECO/POWER Modes';
              } else {
                trimObj.features[index] = replaceString('&bull;', '', val);
                trimObj.features[index] = replaceString('<br/>&bull;', '', val);
                trimObj.features[index] = replaceString('&lt', '', val);
              }
            }
          }

          /*
          console.group('features data');
          console.log('before:', featuresInit);
          console.log('after:', trimObj.features);
          console.groupEnd();
          */
          trimObj.model = __modelTitle(currentObj.name); // remove Prius C and V from model
          trimObj.code = currentObj.code;
          // BAT-2282 if model is the same as modelTitle, then drop it (if there's only one trim for a vehicle, VAPI passes the trim name the same as the series name)
          if (trimObj.series === currentObj.code || trimObj.seriesSanitized === currentObj.name) {
            trimObj.model = '';
          }
          // BAT-2282 the Rav 4 trimObj.model's contain 'Hybrid' in them. Remove those
          if (trimObj.series.toUpperCase() === 'RAV4HYBRID') {
            trimObj.model = trimObj.model.replace(' Hybrid', '');
          }
        }
      });

      // FMP-6 add engineType data to this trim
      test.some(function (currentObj) {
        var hasEngine = __hasValue(currentObj, 'type', 'engine');
        if (hasEngine) {
          trimObj.engineType = currentObj.name;
          trimObj.dataLayer.series_engine = currentObj.name;
        }
      });

      // FMP-6 add transmission data to this trim
      test.some(function (currentObj) {
        var hasTransmission = __hasValue(currentObj, 'type', 'transmission');
        if (hasTransmission) {
          trimObj.transmission = currentObj.name; // are we sure we don't want code here?
          trimObj.dataLayer.series_transmission = currentObj.name; // are we sure we don't want code here?
        }
      });

      // if this trimObj is missing a code (some are!), then don't use it
      if (trimObj.code.length !== 0) {
        trimArrTemp.push(trimObj);
      }
    }
    // console.log('trim cards: ', trimArrTemp);

    // if trim models match, keep the one with the lowest MSRP only.
    var finalHash = {};
    var sanitizedTrims = [];
    var codesUsed = [];

    // build a hashmap to find which, of our duplicate models, has the lowest MSRP
    for (var j = 0; j < trimArrTemp.length; j++) {
      if (trimArrTemp[j].code in finalHash) {
        if (finalHash[trimArrTemp[j].code] > trimArrTemp[j].msrp) {
          finalHash[trimArrTemp[j].code] = trimArrTemp[j].msrp;
        }
      } else {
        finalHash[trimArrTemp[j].code] = trimArrTemp[j].msrp;
      }
    }
    /* console.group('Our CLS response may contain duplicate "grades". Keep only those with the lower MSRP: ')
    console.table(finalHash);
    console.groupEnd() */

    // based on hashmap, add only those models with the lowest MSRP to our trimArrTemp.
    // Sprinkle in data from our EFC response at this time
    for (var k = 0; k < trimArrTemp.length; k++) {
      var thisCode = trimArrTemp[k].code;
      var thisMsrp = trimArrTemp[k].msrp;

      if (thisMsrp === finalHash[thisCode]) {
        var lowerCode = thisCode.toLowerCase();
        var isDuplicate = (codesUsed.indexOf(lowerCode) > -1);
        codesUsed.push(lowerCode);
        trimArrTemp[k].duplicate = isDuplicate;
        trimArrTemp[k].msrp = readableMonetize(thisMsrp);

        if (trimArrTemp[k].features.length === 1) {
          trimArrTemp[k].features = __featuresSplit(trimArrTemp[k].features[0]);
        }

        if (trimArrTemp[k].duplicate === false) {
          sanitizedTrims.push(trimArrTemp[k]);
        }
      }
    }

    // sort on trimsArr[x].msrp to display models in MSRP ASC order
    sanitizedTrims.sort(function (a, b) {
      return parseFloat(a.msrp) - parseFloat(b.msrp);
    });

    // BAT-3645 - adjust seriesSanitized and model properties for display correctly
    // when seriesSanitized==model or seriesSanitized contained in model
    // TODO: move to xform
    var finalSanitizedTrims = sanitizedTrims;

    finalSanitizedTrims = $.extend(true, [], sanitizedTrims);
    for (var ti = 0; ti < finalSanitizedTrims.length; ti += 1) {
      var tiitm = finalSanitizedTrims[ti];
      if (!(tiitm.model)) {
        tiitm.model = tiitm.seriesSanitized;
      }
      if (tiitm.seriesSanitized && tiitm.model
        && (tiitm.model == tiitm.seriesSanitized || tiitm.model.substr(0, tiitm.seriesSanitized.length + 1) == (tiitm.seriesSanitized + ' '))) {
        tiitm.seriesSanitized = '';
      }
    }

    return finalSanitizedTrims;
  };
});

